import { useEffect, useState } from "react";
import { request } from "../api/client";
import { useLocale } from "../i18n";

export const qualificationChanged = "mzn:qualifications-changed";

/** Mounted only while the selected organization permits qualification review. */
export function QualificationCount() {
  const { w, lang } = useLocale();
  const [count, setCount] = useState<number | null>(null);
  useEffect(() => {
    let current: AbortController | undefined;
    let disposed = false;
    async function refresh() {
      current?.abort();
      if (document.visibilityState === "hidden") return;
      const controller = new AbortController(); current = controller;
      try {
        const result = await request<{ pendingCount: number }>("/qualifications/summary", "GET", undefined, controller.signal);
        if (!Number.isSafeInteger(result.pendingCount) || result.pendingCount < 0) throw new Error("Invalid qualification count");
        if (!disposed && !controller.signal.aborted) setCount(result.pendingCount);
      } catch {
        if (!disposed && !controller.signal.aborted) setCount(null);
      }
    }
    const update = () => { void refresh(); };
    update();
    const timer = window.setInterval(update, 60000);
    window.addEventListener(qualificationChanged, update);
    window.addEventListener("focus", update);
    document.addEventListener("visibilitychange", update);
    return () => {
      disposed = true; current?.abort(); window.clearInterval(timer);
      window.removeEventListener(qualificationChanged, update);
      window.removeEventListener("focus", update);
      document.removeEventListener("visibilitychange", update);
    };
  }, []);
  if (count === null) return null;
  const label = w(`${count} طلب بانتظار المراجعة`, `${count} requests pending review`);
  return <b className="qualification-count" aria-label={label} title={label}>{new Intl.NumberFormat(lang).format(count)}</b>;
}
